import { useEffect, useRef, useState } from 'react';
import type { SourceLink as SourceLinkType } from '../types';

export function Spinner({ label }: { label?: string }) {
  return (
    <span className="pa-spin" role="status" aria-live="polite">
      <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" style={{ animation: 'pa-rot 0.8s linear infinite' }}>
        <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2" />
        <path d="M8 2a6 6 0 0 1 6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      {label ? <span>{label}</span> : null}
    </span>
  );
}

export function Check() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
      <path d="M2.5 6.2l2.2 2.3 4.8-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function SourceLink({ source }: { source: SourceLinkType }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button type="button" className="pa-src" onClick={() => { setOpen((v) => !v); }}>
        {source.label}
      </button>
      {open ? (
        <div className="pa-popover" role="dialog" aria-label={source.label} style={{ left: 0, top: 22 }}>
          <p className="pa-popover-title">{source.label}</p>
          <p className="pa-meta" style={{ margin: 0 }}>
            {source.detail ?? 'From payer rules and your office’s own history. No other patients’ names are shown.'}
          </p>
        </div>
      ) : null}
    </div>
  );
}

export function SourceRow({ sources }: { sources: SourceLinkType[] }) {
  if (sources.length === 0) return null;
  return (
    <div className="pa-srcrow">
      {sources.map((s) => (
        <SourceLink key={s.id} source={s} />
      ))}
    </div>
  );
}
